import React, { useState } from "react";
import { useHistory, useLocation, useParams } from "react-router-dom";
import "../../assets/styles/components/model.scss";
import "../../assets/styles/ant/modal.scss";
import { Modal, Button, Space } from "antd";
import { Icon } from "@iconify/react";
import {
  mdiClose,
  mdiAlertOutline,
  mdiVanish,
  mdiCheckCircleOutline,
} from "@mdi/js";
import { Spin } from "antd";
interface Props {
  show?: boolean;
  cancelModal?: () => void;
  type?: number;
  path?: string;
}

const Model: React.FC<Props> = ({ show, cancelModal, type = 1, path }) => {
  const navigate = useHistory();
  const typeModal = [
    {
      text: "ผู้ใช้งานท่านนี้มีประวัติ OPD แล้ว",
      subtext: "This user has a history of OPD.",
      icon: "clarity:warning-standard-line",
      btnTitle: "VIEW OPD",
      to: `/opd/search/${path}`,
    },
    {
      text: "กรุณาเสียบบัตรประชาชนที่ช่องเสียบบัตร",
      subtext: "Please insert your ID card.",
      icon: "eos-icons:bubble-loading",
      btnTitle: "SUBMIT",
      to: "#",
      type: "checkidcard",
    },
    {
      text: "ยังไม่มีประวัติ OPD ของผู้ใช้งานท่านนี้",
      text2: "ต้องการเปิด OPD หรือไม่?",
      subtext: "No OPD found.",
      subtext2: "Want to Create OPD?",
      icon: "clarity:warning-standard-line",
      btnTitle: "SUBMIT",
      to: "#",
    },
  ];

  const navigateTo = async () => {
    navigate.push(`${typeModal[type]?.to}`);
  };

  return (
    <div className="modal-opd">
      <div>
        <Modal
          visible={show}
          onOk={cancelModal}
          onCancel={cancelModal}
          footer={false}
          centered
          className="modal-custom"
        >
          <div className="icon-modal">
            <Icon
              icon={typeModal[type]?.icon}
              color="#86CFC6"
              width="16%"
              height="16%"
              style={{ margin: "15px 0px 28px" }}
            />
          </div>
          <div className="text-modal">
            <h5>{typeModal[type]?.text}</h5>
            <h5>{typeModal[type]?.text2}</h5>
            <h5>{typeModal[type]?.subtext}</h5>
            <h5>{typeModal[type]?.subtext2}</h5>
          </div>
          <div className="btn-confirm">
            <Button
              onClick={typeModal[type]?.to !== "#" ? navigateTo : cancelModal}
            >
              {typeModal[type]?.btnTitle}
            </Button>
          </div>
        </Modal>
      </div>
    </div>
  );
};
export default Model;
